function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { saveActiveGiveawayTypeCreator } from 'swag-client-common/redux/partials/giveaway-selected/giveaway-selected.actions';
import { getGiveawayProductDefaultSize } from 'swag-common/business-logic/giveaway/giveaway-product-size-variants';
import { getUniqueColorsOfProductWithQuantities } from '../../../../custom-store-admin/redux/products/products.selectors';
import { setGiveawayLandingVariantColorTypeCreator, setGiveawayLandingVariantSizeTypeCreator } from '../giveaway-color-and-size-variants.actions';
import { removeGiveawayLandingActiveItemTypeCreator, setGiveawayLandingActiveItemTypeCreator } from '../giveaway-landing.actions';
export const defaultGiveawayVariant = {
  colors: [],
  size: ''
};
export const giveawayColorAndSizeVariantsInitialState = {};
export const giveawayColorAndSizeVariantsReducerFactory = storePrefix => (state = giveawayColorAndSizeVariantsInitialState, action) => {
  switch (action.type) {
    case setGiveawayLandingVariantSizeTypeCreator(storePrefix):
      {
        const {
          productId,
          size
        } = action.payload;
        const variant = state[productId] || {};
        return _objectSpread({}, state, {
          [productId]: _objectSpread({}, defaultGiveawayVariant, variant, {
            size
          })
        });
      }
    case setGiveawayLandingVariantColorTypeCreator(storePrefix):
      {
        const {
          giveawayColorAndSizeVariantsState
        } = action.payload;
        return giveawayColorAndSizeVariantsState;
      }
    case setGiveawayLandingActiveItemTypeCreator(storePrefix):
      {
        const product = action.payload;
        const colors = getUniqueColorsOfProductWithQuantities(product);
        const prevSelection = state[product._id] || {};
        const prevColors = prevSelection.colors || [];
        const size = prevSelection.size || getGiveawayProductDefaultSize(product);
        if (colors.length === 1 && !prevColors.length) {
          return _objectSpread({}, state, {
            [product._id]: _objectSpread({}, prevSelection, {
              size,
              colors: [colors[0].colorValue]
            })
          });
        }
        return state;
      }
    case removeGiveawayLandingActiveItemTypeCreator(storePrefix):
      {
        const productId = action.payload;
        const newState = _objectSpread({}, state);
        newState[productId] = defaultGiveawayVariant;
        return newState;
      }
    case saveActiveGiveawayTypeCreator(storePrefix):
      {
        const giveaway = action.payload;
        const defaultGiveawayVariants = giveaway.products.reduce((acc, product) => {
          const defaultVariant = _objectSpread({}, defaultGiveawayVariant);
          defaultVariant.size = getGiveawayProductDefaultSize(product);
          return _objectSpread({}, acc, {
            [product._id]: defaultVariant
          });
        }, {});
        return _objectSpread({}, state, defaultGiveawayVariants);
      }
    default:
      {
        return state;
      }
  }
};